/* eslint-disable no-restricted-syntax -- Itt lehet. */

// https://addyosmani.com/blog/lazy-loading/

import { debounce } from '../utils/utils'

import doLazyLoad from './utils/doLazyLoad'

const DEFAULT_DEBOUNCE_TIME =  50

interface IProps {
  readonly fallbackSrc?: string
  readonly checkOnResize?: boolean
  readonly checkOnScroll?: boolean
  readonly debounceTime?: number
  readonly attr?: string
}

/**
 * LazyLoad init.
 * @deprecated Használd helyette a common/IntersectionObservert-t!
 * @param      props - Adat.
 */
export default function lazyLoad (props: IProps = {}): TUnknownCallback {
  const attr = props.attr ?? 'data-src'
  const debounceTime = props.debounceTime ?? DEFAULT_DEBOUNCE_TIME

  const func = debounce(() => doLazyLoad(attr, props.fallbackSrc), debounceTime)

  // --- Alapból mindig van resize és scroll check, de false-al ki lehet kapcsolni.

  if (props.checkOnResize !== false) {
    window.addEventListener('resize', func)
  }

  if (props.checkOnScroll !== false) {
    window.addEventListener('scroll', func)
  }

  func()

  return func
}
